module.exports = __webpack_public_path__ + "static/media/content.b02e84c0.svg";